module.exports = __webpack_public_path__ + "img/ubuntu-v14-latin-700.b0c73dd.svg";